"use strict";
exports.__esModule = true;
exports.getSelectedWorkitemFromInvoice = exports.isWorkitemSelected = exports.GroupWorkitemsByStatus = exports.renderWorkitemInItemSelector = exports.renderWorkItemLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var renderWorkItemLabel = function (workitem) {
    var _a;
    return (_a = workitem.data) === null || _a === void 0 ? void 0 : _a.assignee;
};
exports.renderWorkItemLabel = renderWorkItemLabel;
var renderWorkitemInItemSelector = function (workitem) {
    var _a;
    return (0, jsx_runtime_1.jsx)("div", { children: (_a = workitem.data) === null || _a === void 0 ? void 0 : _a.assignee });
};
exports.renderWorkitemInItemSelector = renderWorkitemInItemSelector;
var WorkItemStatus;
(function (WorkItemStatus) {
    WorkItemStatus["IN_CQA"] = "IN PROGRESS";
    WorkItemStatus["CQA_COMPLETE"] = "COMPLETE";
    WorkItemStatus["CQA_APPROVED"] = "APPROVED";
})(WorkItemStatus || (WorkItemStatus = {}));
var GroupWorkitemsByStatus = function (workitems) {
    // Create new groups array with empty items arrays each time
    var groups = [
        {
            label: WorkItemStatus.IN_CQA,
            items: []
        },
        {
            label: WorkItemStatus.CQA_COMPLETE,
            items: []
        },
        {
            label: WorkItemStatus.CQA_APPROVED,
            items: []
        }
    ];
    workitems.forEach(function (workitem) {
        var qaStatus = workitem.data.qa_status;
        var group = groups.find(function (group) { return group.label === WorkItemStatus[qaStatus]; });
        if (group) {
            group.items.push(workitem);
        }
    });
    return groups;
};
exports.GroupWorkitemsByStatus = GroupWorkitemsByStatus;
var isWorkitemSelected = function (selectedWorkitem, currentWorkitem) {
    var _a, _b;
    return ((_a = selectedWorkitem === null || selectedWorkitem === void 0 ? void 0 : selectedWorkitem.data) === null || _a === void 0 ? void 0 : _a.case_id) === ((_b = currentWorkitem.data) === null || _b === void 0 ? void 0 : _b.case_id);
};
exports.isWorkitemSelected = isWorkitemSelected;
var getSelectedWorkitemFromInvoice = function (cursorAPIContext, workitems) {
    var selectedWorkitemIndex = workitems.findIndex(function (workitem) { return workitem.data.case_id === cursorAPIContext.workitemId; });
    return [workitems[selectedWorkitemIndex], selectedWorkitemIndex];
};
exports.getSelectedWorkitemFromInvoice = getSelectedWorkitemFromInvoice;
//# sourceMappingURL=workitem-selector.js.map